import { TripBookingGuideline } from '../../lib/types/models/trip-booking/trip-booking-guildeline'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripBookingGuideline(data: UpdateInput<TripBookingGuideline>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.tripBookingGuidelines.update.url, { id }))
    .patch(rest)
}
